import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import ReactSVG from 'react-svg';
import style from './styles/style.module.css';

import logoutIcon from 'appSrc/assets/icons/custom/leave.svg';
import finishedFormIcon from 'appSrc/assets/icons/custom/forms.svg';
import starIcon from 'appSrc/assets/icons/custom/star.svg';
import plusColoredIcon from 'appSrc/assets/icons/custom/plus-colored.svg';
import lifeSaverIcon from 'appSrc/assets/icons/custom/life-preserver.svg';
import personIcon from 'appSrc/assets/icons/custom/person.svg';
import activeHeartIcon from 'appSrc/assets/img/active-heart.svg';
import uploadIcon from 'appSrc/assets/icons/custom/upload.svg';
import curatorBadge from 'appSrc/assets/icons/custom/check-circle.svg';
import searchIcon from 'appSrc/assets/icons/custom/search.svg';

//v4
import hamburgerIcon from 'appSrc/assets/v4/icons/custom/hamburger.svg';
import xIcon from 'appSrc/assets/v4/icons/custom/x.svg';
import bagIcon from 'appSrc/assets/v4/icons/custom/bag.svg';
import carouselNextIcon from 'appSrc/assets/v4/icons/custom/next.svg';
import carouselPrevIcon from 'appSrc/assets/v4/icons/custom/c-back.svg';
import playIcon from 'appSrc/assets/v4/icons/custom/play.svg';
import heartIcon from 'appSrc/assets/v4/icons/custom/heart-empty.svg';
import largePlayIcon from 'appSrc/assets/v4/icons/custom/play-large.svg';
import arrowRightIcon from 'appSrc/assets/v4/icons/custom/arrow-right.svg';
import shareIcon from 'appSrc/assets/v4/icons/custom/share.svg';


export default class Icon extends PureComponent {
    determineIcon = ( iconName, source ) => {
        var iconFile = null;

        switch ( source ) {
            case 'fontAwesome':
                var [ category, icon ] = iconName.split( '/' );
                switch ( category ) {
                    case 'fas':
                        iconFile = fas[ icon ];
                        break;
                    case 'fab':
                        iconFile = fab[ icon ];
                        break;
                    case 'far':
                        iconFile = far[ icon ];
                        break;
                }
                break;
            default:
                switch ( iconName ) {
                    case 'logout':
                        iconFile = logoutIcon;
                        break;
                    case 'finished-form':
                        iconFile = finishedFormIcon;
                        break;
                    case 'plus-colored':
                        iconFile = plusColoredIcon;
                        break;
                    case 'star':
                        iconFile = starIcon;
                        break;
                    case 'life-saver':
                        iconFile = lifeSaverIcon;
                        break;
                    case 'person':
                        iconFile = personIcon;
                        break;
                    case 'heart':
                        iconFile = heartIcon;
                        break;
                    case 'heart-filled':
                        iconFile = activeHeartIcon;
                        break;
                    case 'upload':
                        iconFile = uploadIcon;
                        break;
                    case 'verified-badge':
                        iconFile = curatorBadge;
                        break;
                    case 'search':
                        iconFile = searchIcon;
                        break;
                    case 'hamburger':
                        iconFile = hamburgerIcon;
                        break;
                    case 'x':
                        iconFile = xIcon;
                        break;
                    case 'bag':
                        iconFile = bagIcon;
                        break;
                    case 'play':
                        iconFile = playIcon;
                        break;
                    case 'play-large':
                        iconFile = largePlayIcon;
                        break;
                    case 'carousel-next':
                        iconFile = carouselNextIcon;
                        break;
                    case 'carousel-prev':
                        iconFile = carouselPrevIcon;
                        break;
                    case 'arrow-right':
                        iconFile = arrowRightIcon;
                        break;
                    case 'share':
                        iconFile = shareIcon;
                        break;
                }
                break;
        }
        return iconFile;
    }
    render() {
        const { icon, source } = this.props;
        const iconFile = this.determineIcon( icon, source );


        var inlineStyles = { ...this.props.style };
        if( this.props.size && parseInt( this.props.size ) ) {
            inlineStyles.height = inlineStyles.height || 'auto';
            inlineStyles.width = this.props.size + 'px';
        }

        var iconName = '';
        var iconComponent = null;
        switch ( this.props.source ) {
            case 'fontAwesome':
                iconName = iconFile.iconName;
                iconComponent = ( <FontAwesomeIcon icon={ iconFile } style={ this.props.faStyle } size={ this.props.faSize } /> );
                break;
            case 'customSvg':
                iconName = icon;
                return (
                    <ReactSVG src={ iconFile } title={ this.props.title } alt={ this.props.alt }
                    className={ `icon ${ iconName } ${ this.props.className } ${ style.icon }` }
                    disabled={ this.props.disabled }
                    style={ inlineStyles }
                    onClick={ this.props.onClick } />
                );
            default:
                iconName = icon;
                iconComponent = ( <img src={ iconFile } title={ this.props.label } alt={ this.props.alt } /> );
        }

        return (
            <i className={ `icon ${ iconName } ${ this.props.className } ${ style.icon }`.trim() }
            style={ inlineStyles }
            alt={ this.props.alt }
            title={ this.props.title }
            disabled={ this.props.disabled }
            onClick={ this.props.onClick }>
                { iconComponent }
            </i>
        );
    }
}
Icon.defaultProps = {
    className: '',
    alt: 'icon',
    icon: '',
    source: 'custom',
    onClick: ()=>{},
};
